import React from "react";
import { IconProps } from "../icon";

export const MarkerPin_02Icon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M12 12.5a3 3 0 100-6 3 3 0 000 6z"
    />
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M12 22c2-4 8-6.582 8-12a8 8 0 10-16 0c0 5.418 6 8 8 12z"
    />
  </svg>
);
